// Function to create a 2D array of numbers
export const create2DArray = (rows: number, columns: number, minValue = 0, maxValue = 0): number[][] => {
    const array: number[][] = [];
    for (let i = 0; i < rows; i++) {
        const row: number[] = [];
        for (let j = 0; j < columns; j++) {
            // You can populate the array with any values you like. For this example, I'm using random numbers between 1 and 100.
            row.push(Math.floor(Math.random() * maxValue) + minValue);
        }
        array.push(row);
    }
    return array;
};

export const isNullOrUndefined = (variable: any): Boolean => {
    return variable === null || variable === undefined ? true : false; // Returns true if variable is null or undefined
};
